// extracted by mini-css-extract-plugin
export default {"input":"Input_input__HH4tn","error":"Input_error__QE59n"};